import $ from 'jquery';

$( '.recently-viewed-products__products' ).slick( {
	infinite: true,
	slidesToShow: 5,
	slidesToScroll: 1,
	prevArrow: '<button class="slick-prev"></button>',
	nextArrow: '<button class="slick-next"></button>',
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
			}
		},
		{
			breakpoint: 640,
			settings: {
				slidesToShow: 1,
			}
		},
	]
} );